import { useEffect, useState } from 'react'

import { useDispatch } from 'react-redux'
import { hideLoader, showLoader } from '../../store/actions'
import ProductCardStyleOne from '../Helpers/Cards/ProductCardStyleOne'
import DataIteration from '../Helpers/DataIteration'
import LayoutHomeTwo from '../Partials/LayoutHomeTwo'
import CategoryFilter from './CategoryFilter'

import { useParams } from 'react-router-dom'

import axios from 'axios'
import { BASE_URL } from '../../utils/response'
import './Category.css'

export default function Category() {
    const dispatch = useDispatch()

    const checkboxHandler = (e) => {
        const { name } = e.target
        setFilter((prevState) => ({
            ...prevState,
            [name]: !prevState[name],
        }))
    }

    const [filterToggle, setToggle] = useState(false)

    const [products, setProducts] = useState([])
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [subcategories, setSubcategories] = useState([])

    const { categoryslug } = useParams()

    const [category, setCategory] = useState({})

    const [filterForm, setFilterForm] = useState({
        subCategorySelected: '',
        sort: 'price-DESC',
    })

    const [searchText, setSearchText] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        dispatch(showLoader())
        axios
            .get(`${BASE_URL}/categories-listing-api/${categoryslug}`)
            .then((response) => {
                setCategory(response.data?.data)

                let subcategoryArray = response.data?.data?.childs?.map(
                    (category, index) => {
                        return {
                            slug: category.slug,
                            title: category.slug,
                        }
                    }
                )

                setSubcategories(subcategoryArray)
                setFilterForm({
                    subCategorySelected: '',
                    sort: 'price-DESC',
                })
                setSearchText('')
                dispatch(hideLoader())
            })
    }, [categoryslug])

    useEffect(() => {
        applyFilter()
    }, [category])

    useEffect(() => {
        applyFilter()
    }, [filterForm, page])

    const applyFilter = () => {
        setIsLoading(true)
        let url = `${BASE_URL}/products-listing-api?per_page=9&page_no=${page}`

        if (filterForm.subCategorySelected === '') {
            url =
                url +
                ('&category=' + encodeURI(category.label).replace('&', '%26'))
        } else {
            url =
                url + ('&category=' + encodeURI(filterForm.subCategorySelected))
        }

        url =
            url +
            ('&order_by=' +
                filterForm.sort.split('-')[0] +
                '&order_as=' +
                filterForm.sort.split('-')[1])

        url = searchText ? url + ('&search=' + searchText) : url

        axios.get(url).then((response) => {
            let productArray = response.data?.data?.records?.map(
                (product, index) => {
                    return {
                        id: product.id,
                        image: product.ImgURL + product.thumbnail,
                        review: product.review ? product.review : 4,
                        title: product.label,
                        offer_price: product.price ? product.price : 22,
                        price: product.variants.filter(
                            (x) => x.is_available == 1
                        )[0]
                            ? product.variants.filter(
                                  (x) => x.is_available == 1
                              )[0]?.price
                            : 0,
                        campaingn_product: false,
                        product_type: null,
                        slug: product.slug,
                    }
                }
            )
            setTotal(response.data?.data?.pagination?.total)
            // Don't override the page state from API response
            // setPage(response.data?.data?.pagination?.current_page)
            setProducts(productArray)
            setIsLoading(false)
        }).catch((error) => {
            console.error('Error fetching products:', error)
            setIsLoading(false)
        })
    }

    const subCategoryHandler = (selectedOption) => {
        setFilterForm({
            ...filterForm,
            subCategorySelected: selectedOption,
        })
    }

    const sortHandler = (value) => {
        setFilterForm({
            ...filterForm,
            sort: value,
        })
    }

    const searchTextHandler = (value) => {
        setSearchText(value)
    }

    const onSearch = () => {
        applyFilter()
    }

    const handlePageChange = (newPage) => {
        console.log('Changing page from', page, 'to', newPage)
        setPage(newPage)
        // Don't call applyFilter here as it will be called by useEffect
    }

    const renderPagination = () => {
        const totalPages = Math.ceil(total / 9)
        const currentPage = page
        const pages = []
        
        if (totalPages <= 1) {
            return null
        }
        
        pages.push(
            <button
                key="prev"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={isLoading || currentPage === 1}
                className={`w-10 h-10 rounded-lg border-2 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm hover:shadow-md flex items-center justify-center ${
                    currentPage === 1 
                        ? 'border-gray-300 text-gray-400 cursor-not-allowed' 
                        : 'bg-[rgb(0_86_153)] text-white border-[rgb(0_86_153)] shadow-lg hover:shadow-xl'
                }`}
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
            </button>
        )

        const maxPagesToShow = Math.min(10, totalPages)
        
        for (let i = 1; i <= maxPagesToShow; i++) {
            pages.push(
                <button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    disabled={isLoading}
                    className={`w-10 h-10 rounded-lg border-2 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm hover:shadow-md ${
                        i === currentPage
                            ? 'bg-[rgb(0_86_153)] text-white border-[rgb(0_86_153)] shadow-lg'
                            : 'border-[rgb(0_86_153)] text-[rgb(0_86_153)] hover:bg-[rgb(0_86_153)] hover:text-white hover:scale-105'
                    }`}
                >
                    {i}
                </button>
            )
        }

        pages.push(
            <button
                key="next"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={isLoading || currentPage === totalPages}
                className={`w-10 h-10 rounded-lg border-2 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm hover:shadow-md flex items-center justify-center ${
                    currentPage === totalPages 
                        ? 'border-gray-300 text-gray-400 cursor-not-allowed' 
                        : 'bg-[rgb(0_86_153)] text-white border-[rgb(0_86_153)] shadow-lg hover:shadow-xl'
                }`}
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
            </button>
        )

        return pages
    }

    return (
        <>
            <LayoutHomeTwo>
                <div className="products-page-wrapper w-full">
                    <div className="container-x mx-auto">
                        <div className="w-full lg:flex lg:space-x-[30px]">
                            <div className="lg:w-[270px]">
                                <CategoryFilter
                                    className="mb-[30px]"
                                    subCategoryHandler={subCategoryHandler}
                                    subcategories={subcategories}
                                    subCategorySelected={
                                        filterForm.subCategorySelected
                                    }
                                    sortSelected={filterForm.sort}
                                    sortHandler={sortHandler}
                                    searchText={searchText}
                                    searchTextHandler={searchTextHandler}
                                    onSearch={onSearch}
                                />
                                {/* ads */}
                                <div className="w-full hidden lg:block h-[295px]">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/ads-5.png`}
                                        alt=""
                                        className="w-full h-full object-contain"
                                    />
                                </div>
                            </div>

                            <div className="flex-1">
                                <div className="products-sorting w-full bg-white md:h-[70px] flex md:flex-row flex-col md:space-y-0 space-y-5 md:justify-between md:items-center p-[30px] mb-[40px]">
                                    <div>
                                        <p className="font-400 text-[13px]">
                                            <span className="text-qgray">
                                                {' '}
                                                Showing
                                            </span>{' '}
                                            {Math.min((page - 1) * 9 + 1, total)}–{Math.min(page * 9, total)} of {total}{' '}
                                            results
                                        </p>
                                    </div>
                                    <div className="flex space-x-3 items-center">
                                        <span className="font-400 text-[13px]">
                                            Sort by:
                                        </span>
                                        <div className="flex space-x-3 items-center">
                                            <select
                                                value={filterForm.sort}
                                                onChange={(event) => {
                                                    sortHandler(
                                                        event.target.value
                                                    )
                                                }}
                                            >
                                                <option value="title-ASC">
                                                    Name: A - Z
                                                </option>
                                                <option value="title-DESC">
                                                    Name: Z - A
                                                </option>
                                                <option value="price-DESC">
                                                    Price: High to Low
                                                </option>
                                                <option value="price-ASC">
                                                    Price: Low to High
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <button
                                        onClick={() => setToggle(!filterToggle)}
                                        type="button"
                                        className="w-10 lg:hidden h-10 rounded flex justify-center items-center border border-qyellow text-qyellow"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-6 w-6"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                                            />
                                        </svg>
                                    </button>
                                </div>
                                {isLoading ? (
                                    <div className="flex justify-center items-center py-20">
                                        <div className="flex flex-col items-center space-y-4">
                                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
                                            <p className="text-gray-600 font-medium">Loading products...</p>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="grid xl:grid-cols-3 sm:grid-cols-2 grid-cols-1  xl:gap-[30px] gap-5 mb-[40px]">
                                        <DataIteration
                                            datas={products}
                                            startLength={0}
                                            endLength={products.length}
                                        >
                                            {({ datas }) => (
                                                <div
                                                    data-aos="fade-up"
                                                    key={datas.id}
                                                >
                                                    <div
                                                        data-aos="fade-up"
                                                        key={datas.id}
                                                    >
                                                        <ProductCardStyleOne
                                                            datas={datas}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </DataIteration>
                                    </div>
                                )}

                                {/* Pagination */}
                                {total > 0 && (
                                    <div className={`w-full flex justify-center items-center space-x-2 mb-[40px] transition-opacity duration-300 ${isLoading ? 'opacity-50' : 'opacity-100'}`}>
                                        {renderPagination()}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </LayoutHomeTwo>
        </>
    )
}
